import React from 'react';

const SchedulingContact = () => {
  const upcomingTrainings = [
    { month: "January 2024", course: "SIS Lifecycle Management", location: "Houston, TX" },
    { month: "February 2024", course: "Functional Safety Audit", location: "Online" },
    { month: "March 2024", course: "SIL & LOPA Practical", location: "Dubai, UAE" },
    { month: "April 2024", course: "SIS Lifecycle Management", location: "Calgary, AB" }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Schedule Your Training</h2>
          <p className="text-xl text-gray-600">Join our upcoming sessions or request custom training</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Upcoming Public Trainings</h3>
            <div className="space-y-4">
              {upcomingTrainings.map((training, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex justify-between items-center">
                    <div>
                      <h4 className="font-semibold text-gray-900">{training.course}</h4>
                      <p className="text-gray-600">{training.month}</p>
                    </div>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                      <i className="fas fa-map-marker-alt mr-2"></i>{training.location}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Request Custom Training</h3>
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <p className="text-gray-600 mb-6">
                Need training tailored to your team's specific needs? We offer customized programs 
                delivered at your facility or online.
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="fas fa-check-circle text-green-500 mr-3"></i>
                  <span className="text-gray-700">Customized curriculum</span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-check-circle text-green-500 mr-3"></i>
                  <span className="text-gray-700">Flexible scheduling</span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-check-circle text-green-500 mr-3"></i>
                  <span className="text-gray-700">On-site or virtual delivery</span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-check-circle text-green-500 mr-3"></i>
                  <span className="text-gray-700">Group discounts available</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-16 bg-blue-600 text-white p-12 rounded-lg text-center">
          <i className="fas fa-calendar-alt text-6xl mb-6 block"></i>
          <h3 className="text-3xl font-bold mb-4">Ready to Enhance Your Team's Skills?</h3>
          <p className="text-xl mb-8">Contact us today to discuss your training needs</p>
          <div className="flex justify-center">
            <a 
              href="mailto:sales@functionalsafetysystem.com" 
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors inline-block"
            >
              <i className="fas fa-envelope mr-2"></i>Email Inquiry
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SchedulingContact;
